export default "__VITE_ASSET__8YVw3ONr__"